import React from 'react';
import { PrimaryButton } from '@fluentui/react/lib/Button';
//import { useSelector } from 'react-redux';
import { createTeamsDeepLink } from '../../helpers/HelperMethods';
import { msTeamsProvisionerApp } from '../../GlobalConst/globalConst';
import * as microsoftTeams from "@microsoft/teams-js";

const styles = {
    root: {       
        position: "absolute",
        top: "40px",
        right: "300px",
        height: "50px",
        zIndex: "10",
        backgroundColor: "#e6e6e6",
        border: "2px solid transparent",
        borderRadius: "4px",    
        "&:hover" : {
            backgroundColor: "#cccccc" ,
            border: "2px solid #000000",
            borderRadius: "4px",
        },
    },  
    label: {
        textTransform: "capitalize",
        fontFamily: "Abb Inside",
        color: "black",
        fontSize: "15px",
        fontWeight: "400",
    },
};

const DemandRequestButton = () => {
    const isMsTeamsApp = false //useSelector((state) => state.app.isMsTeamsApp)

    const onClick = (event, link) => {
        if (isMsTeamsApp) {
            event.preventDefault()
            const deepLink = createTeamsDeepLink(msTeamsProvisionerApp.id, msTeamsProvisionerApp.demandRequestTabId, link, false);
            microsoftTeams.executeDeepLink(deepLink);
        }
    }

    const link = "https://abbnow.service-now.com/cs_gr?id=kb_article&sys_id=161aebe8875f3e1071dca8670cbb3555" 

    return (
        <PrimaryButton 
            className = {styles.root}
            styles = {{ label: styles.label }}
            onClick={(event) => onClick(event, link)}
            href={link}
            target='_blank'
        >
            Contact support
        </PrimaryButton>
    );
}

export default DemandRequestButton;


// WEBPACK FOOTER //
// ./src/components/ManageCenter/DemandRequestButton.js